/**
 * Created by MRQ on 2016/1/15.
 */
'use strict';
angular.module('proManaMentAppHeaderModule', [

]).controller('proMgrAppHeaderRouterCtrl', ['$scope', '$state', 'localStorageService', function($scope, $state, localStorageService) {
    initStatus();
    initData();

    /**
     * [initData description]
     * @return  {[type]}  [return description]
     */
    function initData() {
        let currentNav = $state.current.name.split('.').pop();
        $scope.selectThisNav = currentNav;
        // $scope.selectThisNav = $stateParams.selectTab ? $stateParams.selectTab : (!!$stateParams.channel ? 'column' : 'channel');
    }

    /**
     * [initStatus description]
     * @return  {[type]}  [return description]
     */
    function initStatus() {
        $scope.status = {
            isColumn: $state.params.channel,
            parentchnl: $state.params.parentchnl
        };
        $scope.data = {
            items: []
        };
        // 从缓存中获取权限信息开始
        if (angular.isDefined($state.params.parentchnl)) {
            // 判断为获取栏目访问权限
            $scope.status.rightOperType = localStorageService.get('appRightOperType_channel');
        } else {
            // 判断为获取频道访问权限
            $scope.status.rightOperType = localStorageService.get('appRightOperType_site');
        }
        // 从缓存中获取权限信息结束
        packageData();
    }

    /**
     * [packageData description] 动态组装底部导航条数据
     * @return  {[type]}  [return description]
     */
    function packageData() {
        for (var key in $scope.status.rightOperType.data) {
            switch (key) {
                case 'channel':
                    var data = {};
                    if (angular.isDefined($scope.status.isColumn)) {
                        data = {
                            desc: '栏目管理',
                            flag: 'column'
                        };
                    } else {
                        data = {
                            desc: '栏目管理',
                            flag: 'channel'
                        };
                    }
                    $scope.data.items.push(data);
                    break;
                case 'template':
                    $scope.data.items.push({
                        desc: '模板管理',
                        flag: 'template'
                    });
                    break;
                case 'communications':
                    $scope.data.items.push({
                        desc: '外联模块管理',
                        flag: 'externalsys'
                    });
                    break;
                case 'label':
                    $scope.data.items.push({
                        desc: '标签管理',
                        flag: 'tagmanager'
                    });
                    break;
                case 'publishdistribution':
                    var data = {};
                    if (angular.isUndefined($state.params.channel)) {
                        data = {
                            desc: '分发配置管理',
                            flag: 'distributeconfig'
                        };
                    } else {
                        data = {
                            desc: '栏目分发',
                            flag: 'columndistribution'
                        };
                    }
                    $scope.data.items.push(data);
                    break;
                case 'mark':
                    $scope.data.items.push({
                        desc: '水印管理',
                        flag: 'watermarkmgr'
                    });
                    break;
                case 'interface':
                    $scope.data.items.push({
                        desc: '组件接口管理',
                        flag: 'thirdparty'
                    });
                    break;
            }
        }
    }
}]);
